var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHybridIconBlue = function SvgHybridIconBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-140.000000, -323.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hybryd",
    transform: "translate(140.000000, 323.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Digital-Copy-2",
    transform: "translate(2.000000, 2.000000)",
    fill: "#1DA1F3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,-3.01980663e-14 C11.8359403,-3.01980663e-14 13,1.15126779 13,2.57142857 L13,2.57142857 L13,15.4285714 C13,16.8487322 11.8359403,18 10.4,18 L10.4,18 L2.6,18 C1.16405965,18 8.8817842e-16,16.8487322 8.8817842e-16,15.4285714 L8.8817842e-16,15.4285714 L8.8817842e-16,2.57142857 C8.8817842e-16,1.15126779 1.16405965,-3.01980663e-14 2.6,-3.01980663e-14 L2.6,-3.01980663e-14 Z M10.4,1.28571429 L2.6,1.28571429 C1.88202983,1.28571429 1.3,1.86134818 1.3,2.57142857 L1.3,2.57142857 L1.3,15.4285714 C1.3,16.1386518 1.88202983,16.7142857 2.6,16.7142857 L2.6,16.7142857 L10.4,16.7142857 C11.1179702,16.7142857 11.7,16.1386518 11.7,15.4285714 L11.7,15.4285714 L11.7,2.57142857 C11.7,1.86134818 11.1179702,1.28571429 10.4,1.28571429 L10.4,1.28571429 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50444225,11.7855823 C9.57847976,11.7855823 11,14.3548983 11,15.3530499 C11,15.7227357 10.804541,16 10.4225074,16 L10.4225074,16 L2.5774926,16 C2.19545903,16 2,15.7227357 2,15.3530499 C2,14.3548983 3.42152024,11.7855823 6.50444225,11.7855823 Z M6.50444225,6 C7.74827246,6 8.75222113,7.13678373 8.75222113,8.50462107 C8.75222113,9.96487985 7.74827246,11.0739372 6.50444225,11.064695 C5.25172754,11.0554529 4.24777887,9.96487985 4.24777887,8.50462107 C4.24777887,7.13678373 5.25172754,6 6.50444225,6 Z",
    id: "Combined-Shape"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHybridIconBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hybrid-icon-blue.b15efe15.svg";
export { ForwardRef as ReactComponent };